import { Injectable } from '@angular/core';
import { AppSettings } from '@plugin/settings';
import { HttpClient } from '@angular/common/http';
import { DatabaseCollectionProvider } from '@core/database';

@Injectable({ providedIn: 'root' })
export class ProductVersionService {
    constructor(
        private settings: AppSettings,
        private http: HttpClient,
        private dbProvider: DatabaseCollectionProvider,
    ) {}

    async updateProductVersion() {
        const domain = await this.dbProvider.getApiDomain();
        const protocol = await this.dbProvider.getProtocol();
        const internalId = this.settings.get('internalId');
        const url = `${protocol}://${domain}/api/Patients/${internalId}/productVersion`;
        const { productVersion } = await this.http.get<{ productVersion: string }>(url).toPromise();
        this.settings.set('product-version', productVersion);
    }
}
